module.exports = __webpack_public_path__ + "img/account_verified.a60fdb7f.png";